export interface HsPhotogrammetryProjectFile {
  file: File;
  path: string;
}

export interface HsPhotogrammetryProject {
  name: string;
  files: HsPhotogrammetryProjectFile[];
  objCount: number;
  mtlCount: number;
  textureCount: number;
  totalBytes: number;
}

export function hsSelectPhotogrammetryProject(files: readonly File[]): HsPhotogrammetryProject {
  const folderName: string = files[0]?.webkitRelativePath?.split('/')[0] ?? '';
  const selected: HsPhotogrammetryProjectFile[] = files
    .map((file: File) => {
      const relative: string = file.webkitRelativePath ?? '';
      return { file, path: relative.includes('/') ? relative.slice(relative.indexOf('/') + 1) : file.name };
    })
    .filter((entry: HsPhotogrammetryProjectFile) => /\.(obj|mtl|png|jpe?g)$/i.test(entry.path));

  return {
    name: folderName.length > 0 ? folderName : 'Photogrammetry',
    files: selected,
    objCount: selected.filter((entry: HsPhotogrammetryProjectFile) => /\.obj$/i.test(entry.path)).length,
    mtlCount: selected.filter((entry: HsPhotogrammetryProjectFile) => /\.mtl$/i.test(entry.path)).length,
    textureCount: selected.filter((entry: HsPhotogrammetryProjectFile) => /\.(png|jpe?g)$/i.test(entry.path)).length,
    totalBytes: selected.reduce((sum: number, entry: HsPhotogrammetryProjectFile) => sum + entry.file.size, 0),
  };
}
